import { alpha, Button as MUIButton, Stack as MUIStack } from '@mui/material'
import { grey } from '@mui/material/colors'
import { styled } from '@mui/material'


export const Input = styled("input")(({theme})=>({
    borderRadius: theme.shape.borderRadius,
    border: ".5px solid rgba(255, 255, 255, 0.1)",
    outline: "none",
    backgroundColor: theme.palette.primary.light,
    padding: "0.3rem",
    color: grey["500"],
    '&:focus': {
        boxShadow: `${alpha(theme.palette.secondary.main, 0.25)} 0 0 0 0.2rem`,
        borderColor: theme.palette.primary.main,
    },
}))

export const Button = styled(MUIButton)(()=>({
    textTransform: "capitalize",
    '&:disabled':{
        backgroundColor: grey[500]
    }
}))


export const Stack = styled(MUIStack)(()=>({
    width: "100%",
    height: "100%"
}))